import type { MenuItemProps } from "@mui/material";
import { MenuItem } from "@mui/material";
import { mergeSx } from "helpers/utils";

import variables from "../../../assets/styles/_variables.module.scss";

type StyledMenuItemProps = {
    buttonColor?: "green" | "red" | "orange";
} & MenuItemProps;

const greenButtonStyle = {
    "&.MuiMenuItem-root": {
        margin: "10px",
        color: "#5D9B62",
        fontFamily: "Poppins",
        backgroundColor: "rgba(152, 212, 158, 0.2588235294)",
        borderRadius: variables["border-radius"],
        "&.Mui-selected": {
            color: "#5D9B62",
            backgroundColor: "rgba(152, 212, 158, 0.2588235294) !important",
        },
        "&:hover": {
            backgroundColor: "rgba(152, 212, 158, 0.4) !important",
        },
    },
};

const redButtonStyle = {
    "&.MuiMenuItem-root": {
        margin: "10px",
        color: "#B55D5D",
        fontFamily: "Poppins",
        backgroundColor: "rgba(242, 191, 205, 0.2509803922)",
        borderRadius: variables["border-radius"],
        "&.Mui-selected": {
            color: "#B55D5D",
            backgroundColor: "rgba(242, 191, 205, 0.2509803922) !important",
        },
        "&:hover": {
            backgroundColor: "rgba(242, 191, 205, 0.4) !important",
        },
    },
};

const orangeButtonStyle = {
    "&.MuiMenuItem-root": {
        margin: "10px",
        color: "#AF8442",
        fontFamily: "Poppins",
        backgroundColor: "rgba(244, 160, 34, 0.2509803922)",
        borderRadius: variables["border-radius"],
        "&.Mui-selected": {
            color: "#AF8442",
            backgroundColor: "rgba(244, 160, 34, 0.2509803922) !important",
        },
        "&:hover": {
            backgroundColor: "rgba(244, 160, 34, 0.4) !important",
        },
    },
};

function StyledMenuItem(props: StyledMenuItemProps) {
    const { sx, buttonColor, ...rest } = props;

    const greenButton = buttonColor === "green";
    const redButton = buttonColor === "red";
    const orangeButton = buttonColor === "orange";

    return (
        <MenuItem
            {...rest}
            sx={mergeSx(
                greenButton && greenButtonStyle,
                redButton && redButtonStyle,
                orangeButton && orangeButtonStyle,
                sx,
            )}
        />
    );
}

export default StyledMenuItem;
